import { Divider } from "antd";
import React from "react";
import { Col, FormGroup, FormLabel, Row } from "react-bootstrap";
import { Prompt } from "react-router-dom";
import { labels } from "../../../../localization/labels";
import { messages } from "../../../../localization/messages";
import ButtonBar from "../../../core/ButtonBar/ButtonBar";
import ComponentHeader from "../../../core/ComponentHeader";
import DropDown from "../../../core/DropDown";
import Rating from "../../../core/Rating";
import ResponsiveTabs from "../../../core/ResponsiveTabs/ResponsiveTabs";
import SubmitControl from "../../../core/SubmitControl";
import KnowledgeTypeLookup from "../../Lookups/KnowledgeTypeLookup";
import ClassificationSelection from "../../page/ClassificationSelection";
import SearchSimilar from "../../page/SearchSimilar";
import AdditionalData from "./AdditionalData";
import Document from "./Document";
import EntityRelationships from "./EntityRelationships";
import KnowledgeSource from "./KnowledgeSource";
import LifeCycleHistoryLog from "./LifeCycleHistroyLog";
import MessageLog from "./MessageLog";
import PartyInformations from "./PartyInformations";
import SimilarKnowledge from "./SimilarKnowledge";

const getBody = props => {
  const knowledgeitem = props.entity;
  return (
    <>
      <div className="container">
        <div className="tabVerticalSize" />
        <div className="containerShadow">
          <ComponentHeader
            title={labels.knowledgeItem}
            id={knowledgeitem.id}
            showBackButton
            showShareButton={knowledgeitem.active}
            messageHandler={props.messageHandler}
            shareMailSubject={knowledgeitem.name}
          />
          <div className="bordered_bottom_rounded containerShadow">
            {!props.isNew && knowledgeitem ? (
              <Row>
                <Col sm="2">
                  <FormLabel className="Label">{labels.rating}</FormLabel>
                </Col>
                <Col sm="10">
                  <Rating
                    averageRating={props.knowledgeRatings.averageRating}
                    votesCount={props.knowledgeRatings.votesCount}
                    onRatingChange={props.onRatingChange}
                    rating={props.rating}
                    onRate={props.onRate}
                  ></Rating>
                </Col>
              </Row>
            ) : null}
            {props.isNew && props.searchSimilar ? (
              <SearchSimilar
                messageHandler={props.messageHandler}
                entity={props.entitySimilarSearch}
              />
            ) : null}
            <Row>
              <Col sm="2">
                <FormLabel className="Label">{labels.name}</FormLabel>
              </Col>
              <Col sm="10">
                <FormGroup controlId="name">
                  <SubmitControl
                    autoFocus
                    type="text"
                    title={labels.name}
                    value={knowledgeitem.name}
                    onChange={props.onChange}
                    placeholder={labels.name}
                    validationRule={props.validationRules.name}
                    readOnly={!props.editable}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm="2">
                <FormLabel className="Label">{labels.dateFromTo}</FormLabel>
              </Col>
              <Col sm="5">
                <FormGroup controlId="dateFromTo">
                  <SubmitControl
                    type="dateRange"
                    placeholder={[
                      labels.dateFromPlaceholder,
                      labels.dateToPlaceholder
                    ]}
                    validationRule={props.validationRules?.dateFromTo}
                    value={knowledgeitem.dateFromTo}
                    onChange={props.onChange}
                    controlId={"dateFromTo"}
                    readOnly={!props.editable}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm="2">
                <FormLabel className="Label">{labels.description}</FormLabel>
              </Col>
              <Col sm="10">
                <FormGroup controlId="description">
                  <SubmitControl
                    placeholder={labels.description}
                    as="textarea"
                    value={knowledgeitem.description}
                    onChange={props.onChange}
                    rows="2"
                    readOnly={!props.editable}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm="2">
                <FormLabel className="Label">
                  {labels.descriptionUsage}
                </FormLabel>
              </Col>
              <Col sm="10">
                <FormGroup controlId="descriptionUsage">
                  <SubmitControl
                    as="textarea"
                    title={labels.descriptionUsage}
                    value={knowledgeitem.descriptionUsage}
                    onChange={props.onChange}
                    placeholder={labels.descriptionUsage}
                    readOnly={!props.editable}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm="2">
                <FormLabel className="Label">{labels.knowledgeType}</FormLabel>
              </Col>
              <Col sm="10">
                <FormGroup>
                  <KnowledgeTypeLookup
                    onChange={props.onChange}
                    controlId="knowledgeType"
                    selected={knowledgeitem.knowledgeType}
                    messageHandler={props.messageHandler}
                    placeholder={labels.knowledgeType}
                    required={props.validationRules.knowledgeType?.required}
                    readOnly={!props.editable}
                  />
                </FormGroup>
              </Col>
            </Row>
            {!props.isNew ? (
              <Row>
                <Col sm="2">
                  <FormLabel className="Label">{labels.state}</FormLabel>
                </Col>
                <Col sm="10">
                  <FormGroup controlId="lifeCycle">
                    <DropDown
                      value={knowledgeitem.lifeCycle}
                      options={props.knowledgeLifeCycles.map(x => ({
                        value: x,
                        label: x?.name
                      }))}
                      onChange={props.onChange}
                      targetId={"lifeCycle"}
                      placeholder={labels.lifeCycle}
                      readOnly={!props.lifeCycleEditable}
                    />
                  </FormGroup>
                </Col>
              </Row>
            ) : null}
            {getResponsiveTabsBody(knowledgeitem, props)}
          </div>

          <ButtonBar
            onSave={props.onSave}
            onDelete={props.onDelete}
            disabled={props.disabled}
            readOnly={!props.editable && !props.lifeCycleEditable}
          />
        </div>
      </div>
    </>
  );
};

const getResponsiveTabsBody = (knowledgeitem, props) => {
  const additionalData = (
    <AdditionalData
      validationRules={props.validationRules}
      onChange={props.onChange}
      knowledgeItem={knowledgeitem}
      messageHandler={props.messageHandler}
      setInitialEntityPropertyState={props.setInitialEntityPropertyState}
      editable={props.editable}
    />
  );

  const classificationSelection = (
    <ClassificationSelection
      entity={knowledgeitem}
      messageHandler={props.messageHandler}
      breadcrumbsHandler={props.breadcrumbsHandler}
      setInitialEntityPropertyState={props.setInitialEntityPropertyState}
      setClassificationsOnEntity={props.setClassificationsOnEntity}
      readOnly={!props.editable}
      classificationsFilter={props.classificationsFilter}
    />
  );

  const document = (
    <Document
      entity={knowledgeitem}
      messageHandler={props.messageHandler}
      breadcrumbsHandler={props.breadcrumbsHandler}
      editable={props.editable}
      setNumberOfDocuments={props.setNumberOfDocuments}
    ></Document>
  );

  const knowledgeSource = (
    <KnowledgeSource
      knowledgeItem={knowledgeitem}
      onChange={props.onChange}
      messageHandler={props.messageHandler}
      setInitialEntityPropertyState={props.setInitialEntityPropertyState}
      editable={props.editable}
    />
  );

  const entityRelationships = (
    <div>
      <EntityRelationships
        messageHandler={props.messageHandler}
        breadcrumbsHandler={props.breadcrumbsHandler}
        entity={knowledgeitem}
        entityRelationships={knowledgeitem.entityRelationships}
        addToTable={props.addToRelationshipsTable}
        removeFromTable={props.removeFromRelationshipsTable}
        updateInTable={props.updateInRelationshipsTable}
        reset={props.resetRelationships}
        setInitial={props.setInitialRelationships}
        setAddRelatedEntityRelationship={props.setAddRelatedEntityRelationship}
      />
      <Divider />
      <SimilarKnowledge
        messageHandler={props.messageHandler}
        breadcrumbsHandler={props.breadcrumbsHandler}
        knowledgeItem={knowledgeitem}
        addSimilarKnowledge={props.addRelatedEntityRelationship}
      />
    </div>
  );

  const partyInformations = (
    <PartyInformations
      knowledgeItem={knowledgeitem}
      loadParty={props.loadParty}
    />
  );

  const messageLog = (
    <MessageLog
      messageHandler={props.messageHandler}
      breadcrumbsHandler={props.breadcrumbsHandler}
      entity={knowledgeitem}
    />
  );

  const lifeCycleHistoryLog = (
    <LifeCycleHistoryLog
      entity={knowledgeitem}
      messageHandler={props.messageHandler}
      reload={props.reloadLifeCycleHistoryLog}
      resetReloading={props.resetReloadingLifeCycleHistoryLog}
    />
  );

  const tabs = [
    {
      eventKey: "additionalData",
      title: labels.additionalData,
      body: additionalData
    },
    {
      eventKey: "classification",
      title: labels.classification,
      wrapped: true,
      body: classificationSelection
    },
    {
      eventKey: "knowledgeSource",
      title: labels.knowledgeSource,
      body: knowledgeSource
    },
    {
      eventKey: "documents",
      title: `${labels.documents} (${props.numberOfDocuments})`,
      body: document,
      shouldHide: props.isNew
    },
    {
      eventKey: "entityRelationship",
      title: labels.entityRelationshipRelated,
      body: entityRelationships,
      shouldHide: props.isNew
    },
    {
      eventKey: "partyInfo",
      title: labels.partyInformation,
      body: partyInformations,
      shouldHide: props.isNew
    },
    {
      eventKey: "messageLogs",
      title: labels.messageLog,
      body: messageLog,
      shouldHide: props.isNew
    },
    {
      eventKey: "lifeCycles",
      title: labels.lifeCycle,
      body: lifeCycleHistoryLog,
      shouldHide: !(!props.isNew && knowledgeitem)
    }
  ];

  return (
    <ResponsiveTabs
      tabs={tabs}
      tabClassName="Tab"
      cardClassName="responsiveItemCardSize"
    />
  );
};

const Knowledgeitem = props => (
  <React.Fragment>
    <Prompt
      when={props.shouldBlockNavigation}
      message={messages.changesNotSavedMessage}
    />
    {getBody(props)}
  </React.Fragment>
);

export default Knowledgeitem;
